import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getTemplateFields, getTemplateFieldinfo, updateTemplate } from '@src/store/slices/insurance';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';
import ReactSelect from '@common/ReactSelect';
import * as HELPER from "@src/config/helper";
import { ROLE_FEATURES, APP_TYPE_STANDALONE, APP_TYPE_WITH_UCF, APP_TYPE_RENEWAL, APP_TYPE_AGENCY, TEMPLATE_TYPE_BROKER, TEMPLATE_TYPE_POLICY_SHARED, STATUS_SUCCESS, COUNTRY_CODE, FEATURE_LISTING, SHARE_METHOD } from "@src/config/constant";
import { useDispatch, useSelector } from 'react-redux';
import { getMasterConfig } from '@src/store/slices/common';
import { useLanguage } from "@src/context/LanguageContext";
import Modal from "@src/common/ModalPopup";
import { IS_HQ, TEMPLATE_TYPE } from '@src/config/id/constant';


let initialFilterData = {
    template_type: "",
    template_for: ""
};
let resetWarningMsg = "WARNING! The unsaved template changes will be removed.";
const TABLE_TEMPLATE = [
    '<table style="width:100%; border-collapse: collapse; margin:12px 0;">',
    '  <tbody>',
    '    <tr>',
    '      <td style="border:1px solid #ddd; padding:8px; text-align:left;">&nbsp;</td>',
    '      <td style="border:1px solid #ddd; padding:8px; text-align:left;">&nbsp;</td>',
    '    </tr>',
    '  </tbody>',
    '</table>',
].join('\n');
const TABLE_CELL_STYLE = 'border:1px solid #ddd; padding:8px; text-align:left;';
const TABLE_STYLE = 'width:100%; border-collapse: collapse; margin:12px 0;';
const TABLE_ACTION_CELL_SELECTOR = '[data-template-table-action="add-row"]';
const ENABLE_EMAIL_TEMPLATE_SUBJECT = true;

const stripEditorOnlyTableControlsFromHtml = (html: string) => {
    if (!html) {
        return '';
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    removeEditorOnlyTableControls(doc.body);
    return doc.body.innerHTML;
};

const normalizeDescriptionForEditor = (raw: string) => {
    if (!raw) {
        return '';
    }
    const hasHtmlTag = /<\/?[a-z][\s\S]*>/i.test(raw);
    const normalized = hasHtmlTag ? raw : raw.replace(/\n/g, '<br/>');
    return stripEditorOnlyTableControlsFromHtml(normalized);
};

const normalizePastedTables = (html: string) => {
    if (!html) {
        return html;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    removeEditorOnlyTableControls(doc.body);
    const tables = Array.from(doc.querySelectorAll('table'));
    tables.forEach((table) => {
        table.removeAttribute('width');
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';
        table.style.margin = '12px 0';
        table.setAttribute('style', TABLE_STYLE);
    });
    return doc.body.innerHTML;
};

const applyConsistentTableStyles = (container: HTMLElement | null) => {
    if (!container) {
        return;
    }
    const tables = container.querySelectorAll('table');
    tables.forEach((table) => {
        table.removeAttribute('width');
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';
        table.style.margin = '12px 0';
        table.setAttribute('style', TABLE_STYLE);
    });
};

function removeEditorOnlyTableControls(container: HTMLElement) {
    container.querySelectorAll(TABLE_ACTION_CELL_SELECTOR).forEach((element) => element.remove());
    container.querySelectorAll('.template-table-add-row').forEach((element) => {
        const actionCell = element.closest('td,th');
        (actionCell || element).remove();
    });
}

const SendToFinancierTemplateDetail = (props: any) => {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();


    let [loading, setLoading] = useState(false);

    let [templateDetails, setTemplateDetails] = useState<any>({
        financier_name: "",
        cohort_list: [],
        attributes: {},
        templateType: [],
        templateFor: [],
        dealer_present: []
    })

    const [groupedData, setGroupedData] = useState<any>([]);
    const [selectedFilters, setSelectedFilters] = useState<any>(initialFilterData);
    const [showForm, setShowForm] = useState(false);

    const [templateKey, setTemplateKey] = useState<any>('');
    const [templateLabel, setTemplateLabel] = useState('');
    const editorRef = useRef<HTMLDivElement | null>(null);
    const subjectRef = useRef<HTMLInputElement | null>(null);
    const lastSelectionRef = useRef<Range | null>(null);
    const subjectSelectionRef = useRef({ start: 0, end: 0 });
    const [activeTemplateField, setActiveTemplateField] = useState<'subject' | 'body'>('body');

    const [selectedTemplateData, setSelectedTemplateData] = useState<any>({});

    const [originalGroupedData, setOriginalGroupedData] = useState([]);

    const [showFiled, setShowFiled] = useState(false);
    // eslint-disable-next-line
    const [showTemplateConfiguration, setShowTemplateConfiguration] = useState(true);
    const [originalTemplateType, setOriginalTemplateType] = useState<any[]>([]);
    const [showEmailField, setShowEmailField] = useState(true);
    const [trigger, SetTrigger] = useState(0);

    const [showPermission, setShowPermission] = useState(false);

    const [errField, setErrField] = useState<any>({
        email: "",
        subject: "",
        description: "",
    });

    const [originalDealerSelect, setOriginalDealerSelect] = useState<any[]>([]);
    const [selectedCountryFilters, setSelectedCountryFilters] = useState<any>({});
    const [showEmailIdsModal, setShowEmailIdsModal] = useState(false);
    const [emailModalValue, setEmailModalValue] = useState('');
    const [isEmailEditMode, setIsEmailEditMode] = useState(false);

    const { translations, language } = useLanguage();

    const navigate = useNavigate();

    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common)
    const [isNew, setIsNew] = useState(false);
    const [Placeholders, setPlaceholders] = useState<string[]>([]);
    const [existingGroupData, setExistingGroupData] = useState<any>([]);
    const normalizeQueryValue = (value: string | null) => {
        if (value === null || value === '') {
            return '';
        }
        const numeric = Number(value);
        return Number.isNaN(numeric) ? value : numeric;
    };
    
    const insurerParam = normalizeQueryValue(searchParams.get('insurer_id'));
    const insurerBranch = commonState?.common?.branch_name?.filter((v: any) => v.insurer_id === insurerParam);

     const getTranslatedFieldLabel = (fieldItem: any) => {
        return translations?.EMAIL_TEMPLATE?.[fieldItem?.field_key] || fieldItem?.name || fieldItem?.field_key || '';
    }


    // Handle changes in dropdown selections
    const handleChange = (selectedOption: any, key: string) => {
        let updatedFilters = selectedFilters;
        updatedFilters = { ...updatedFilters, [key]: selectedOption['value'] };
        setSelectedFilters(updatedFilters);
        // set permission
        if ((updatedFilters?.template_for === 1)) {
            setShowPermission(HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['sent_to_insurance_broker'], accessType: 'edit' }));
        }
        else if ((updatedFilters?.template_for === 2)) {
            setShowPermission(HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_policy'], accessType: 'edit' }))
        }

    }

    const handleCountryFilterChange = (selectedOption: any, key: string) => {
        const nextValue = selectedOption?.value ?? '';
        let updatedFilters = { ...selectedCountryFilters, [key]: nextValue };
        if (key === 'partner_id') {
            updatedFilters = { ...updatedFilters, insurer_id: '', branch_id: '' };
        }
        if (key === 'insurer_id') {
            updatedFilters = { ...updatedFilters, branch_id: '' };
        }
        setSelectedCountryFilters(updatedFilters);
        if (COUNTRY_CODE === 'id' && key === 'branch_id') {
            const isEmailTemplate =
                +selectedFilters?.template_type === +TEMPLATE_TYPE?.EMAIL ||
                +selectedTemplateData?.template_type === +TEMPLATE_TYPE?.EMAIL;

            const branchEmail = commonState?.common?.branch_name?.find(
                (v: any) => +(v.value) === +(nextValue)
            )?.email;

            const updateBranch = structuredClone(templateDetails);
            
            const cohort_list = updateBranch?.cohort_list?.find((row:any)=>row.branch_id == nextValue && row.template_for===selectedTemplateData?.template_for && row.template_type===selectedFilters.template_type && row.insurance_type===selectedFilters.insurance_type);
            const nextDescription = normalizeDescriptionForEditor(cohort_list?.description || '');
            const resolvedEmail = isEmailTemplate ? (branchEmail || '') : (cohort_list?.email || selectedTemplateData?.email || '');

            if (isEmailTemplate) {
                setEmailModalValue(resolvedEmail);
            }

            setSelectedTemplateData((prev: any) => ({
                ...prev,
                ...(cohort_list || {}),
                email: resolvedEmail,
                status: cohort_list?.status,
                description: nextDescription,
                subject: cohort_list?.subject || ''
            }));
            
            if (editorRef.current) {
                editorRef.current.innerHTML = nextDescription;
                applyConsistentTableStyles(editorRef.current);
                addTableRowInsertControls(editorRef.current);
            }

            if(nextValue){
                const updateErr = structuredClone(errField);
                delete updateErr?.branch_id;
                setErrField(updateErr);
            }
        }
        if (COUNTRY_CODE === 'id' && (key === 'partner_id' || key === 'insurer_id')) {
            // branch_id resets on these changes, so keep email in sync.
            setSelectedTemplateData((prev: any) => ({ ...prev, email: '' }));
            setEmailModalValue('');
        }
    }

    const getPrefilledCountryFilters = () => {
        const prefilled: any = {};
        const partnerParam = normalizeQueryValue(searchParams.get('insurance_partner_id'));
        const insurerParam = normalizeQueryValue(searchParams.get('insurer_id'));
        const branchParam = normalizeQueryValue(searchParams.get('branch_id'));

        if (partnerParam !== '') {
            prefilled.partner_id = partnerParam;
        }
        if (insurerParam !== '') {
            prefilled.insurer_id = insurerParam;
        }
        if (branchParam !== '') {
            prefilled.branch_id = branchParam;
        }
        return prefilled;
    };

    const getEmailList = (value: string) => {
        if (!value) {
            return [];
        }
        return value
            .split(',')
            .map((email) => email.trim())
            .filter(Boolean);
    };

    const openEmailIdsModal = () => {
        setEmailModalValue(selectedTemplateData?.email || '');
        setIsEmailEditMode(false);
        setShowEmailIdsModal(true);
    };

    const closeEmailIdsModal = () => {
        setShowEmailIdsModal(false);
        setIsEmailEditMode(false);
        setEmailModalValue('');
    };

    const saveEmailIdsModal = async () => {
        const updatedErrors = { ...errField };
        const emailValue = emailModalValue?.trim() || '';
        const emails = emailValue
            .split(",")
            .map((e) => e.trim())
            .filter((e) => e);
        const seen = new Set<string>();

        for (let email of emails) {
            const lowerEmail = email.toLowerCase();

            if (!validEmailRegex.test(lowerEmail)) {
                toast.error(`${translations.RuleEngineAgency?.Email_error_msg} : ${email}`);
                return;
            }
            if (seen.has(lowerEmail)) {
                toast.error(`${translations.BRANCH_CONFIG?.EMAIL_ERROR_DUPLICATE} : ${email}`);
                return;
            }
            if (emailValue.endsWith(",")) {
                toast.error(`${translations.EMAIL_TEMPLATE_RULE_ENGINE?.PLEASE_ENTER_VALID_EMAIL}`);
                return;
            }
            seen.add(lowerEmail);
        }
        // if(emails.length){
        //     delete updatedErrors.email;
        //     setErrField(updatedErrors);
        // }
        const updatedTemplateData = { ...selectedTemplateData, email: emailValue };
        setSelectedTemplateData(updatedTemplateData);
        closeEmailIdsModal();
        if (!isNew && updatedTemplateData?.description?.trim() && updatedTemplateData?.template_type) {
            await SaveTemplateField(updatedTemplateData, true);
        }
    };

    // Fetch data when the component mounts
    useEffect(() => {
        setLoading(true);
        // Fetch template details data
        getTemplateFieldinfo({
            partner_id: searchParams.get('partner_id'),
            ...(COUNTRY_CODE === 'id' && searchParams.get('insurer_id') ? { insurer_id: Number(searchParams.get('insurer_id')), language :language } : {})
        }).then((res: any) => {
            if (res?.status === STATUS_SUCCESS) {
                setTemplateDetails(res.data)

                setOriginalTemplateType(res.data.templateType);
                setOriginalDealerSelect(res.data.dealerPresent)
                setLoading(false);
            }
            else {
                setLoading(false);
                navigate('/email-template-config');
            }
        });
        // eslint-disable-next-line
    }, [trigger, language]);

    useEffect(() => {
        const prefilled = getPrefilledCountryFilters();
        if (Object.keys(prefilled).length) {
            setSelectedCountryFilters(prefilled);
        }
        // eslint-disable-next-line
    }, [searchParams]);


    useEffect(() => {
        setLoading(true);
        // Fetch template fields data
        getTemplateFields().then((res: any) => {
            if (res?.status === STATUS_SUCCESS) {
                // Create an array of child objects sorted by order
                const sortedChildObjects: any = Object.values(res.data)?.map((obj: any) => {
                    const sortedChild = Object.values(obj.child)?.sort((a: any, b: any) => a.order - b.order);
                    return { ...obj, child: sortedChild };
                });
                const newObject = {
                    id: 5,
                    name: "Template Components",
                    parent_id: 0,
                    field_key: "template_components",
                    status: 1,
                    order: 1,
                    send_to_insurance_broker: 1,
                    insurance_policy_shared: 1,
                    child: {
                        "46": {
                            id: 46,
                            name: "Table",
                            parent_id: 4,
                            field_key: "table",
                            status: 1,
                            order: 2,
                            send_to_insurance_broker: 1,
                            insurance_policy_shared: 1,
                            child: []
                        }
                    }
                };
                const formattedNewObject = {
                    ...newObject,
                    child: Object.values(newObject.child).sort(
                        (a: any, b: any) => a.order - b.order
                    )
                };
                const finalData = [...sortedChildObjects, formattedNewObject];
                setGroupedData(finalData);
                setExistingGroupData(finalData);
                setOriginalGroupedData(sortedChildObjects);
                setLoading(false);
            } else {
                setLoading(false);
            }

        });
    }, [])

    const addTemplate: any = () => {
        setShowFiled(false);
        setShowForm(true);
        setIsNew(true);
        setSelectedFilters(initialFilterData);
        setSelectedTemplateData({ status: '1', group_name: ``, template_type: 0, template_for: 0, email: '', subject: '' });
        setSelectedCountryFilters(getPrefilledCountryFilters());
        if (editorRef.current) {
            editorRef.current.innerHTML = '';
        }
        lastSelectionRef.current = null;
        subjectSelectionRef.current = { start: 0, end: 0 };

    }


    const syncEditorState = () => {
        applyConsistentTableStyles(editorRef.current);
        addTableRowInsertControls(editorRef.current);
        const html = getCleanEditorHtml();
        setSelectedTemplateData((prevState: any) => ({ ...prevState, description: html }));
    };

    const getCleanEditorHtml = () => {
        const editor = editorRef.current;
        if (!editor) {
            return '';
        }
        const clone = editor.cloneNode(true) as HTMLElement;
        removeEditorOnlyTableControls(clone);
        return clone.innerHTML;
    };

    const addTableRowInsertControls = (container: HTMLElement | null) => {
        if (!container) {
            return;
        }
        const rows = Array.from(container.querySelectorAll('table tbody tr')) as HTMLTableRowElement[];
        rows.forEach((row) => {
            row.querySelectorAll(TABLE_ACTION_CELL_SELECTOR).forEach((element, index) => {
                if (index > 0) {
                    element.remove();
                }
            });

            if (row.querySelector(TABLE_ACTION_CELL_SELECTOR)) {
                return;
            }

            const actionCell = document.createElement('td');
            actionCell.setAttribute('style', `${TABLE_CELL_STYLE} width:36px; text-align:center;`);
            actionCell.setAttribute('contenteditable', 'false');
            actionCell.setAttribute('data-template-table-action', 'add-row');
            actionCell.innerHTML = '<button type="button" class="template-table-add-row" title="Add row"><i class="ic-add"></i></button>';
            row.appendChild(actionCell);
        });
    };

    const handleEditorInput = () => {
        syncEditorState();
        captureSelection();
    };

    const handleEditorClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const editor = editorRef.current;
        const target = e.target as HTMLElement;
        const actionCell = target.closest(TABLE_ACTION_CELL_SELECTOR) as HTMLTableCellElement | null;

        if (!editor || !actionCell || !editor.contains(actionCell)) {
            captureSelection();
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (!templateKey || Array.isArray(templateKey) || templateKey === 'table') {
            toast.error(translations?.EMAIL_TEMPLATE_RULE_ENGINE?.SELECT_TEMPLATE_FIELD || 'Please select template field');
            return;
        }

        const row = actionCell.closest('tr') as HTMLTableRowElement | null;
        const table = row?.closest('table') as HTMLTableElement | null;
        if (!row || !table) {
            return;
        }

        setPlaceholders((prev: any) => {
            return [...prev, `{{${templateKey}}}`];
        });
        insertRowIntoTable(table, templateLabel || templateKey, templateKey, row);
        syncEditorState();
        setTemplateKey('');
        setTemplateLabel('');
    };


    const handleKeySelect = (e: any, params: any) => {
        e.stopPropagation();

        if (!params.child || (!params?.child?.length)) {
            setTemplateKey(params.field_key);
            setTemplateLabel(getTranslatedFieldLabel(params));
        }
    };

    const getSelectionRangeInEditor = () => {
        const editor = editorRef.current;
        const selection = window.getSelection();
        if (editor && selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            if (editor.contains(range.commonAncestorContainer)) {
                lastSelectionRef.current = range.cloneRange();
                return range;
            }
        }
        if (editor && lastSelectionRef.current && editor.contains(lastSelectionRef.current.commonAncestorContainer)) {
            return lastSelectionRef.current;
        }
        return null;
    };

    const focusEditorToEnd = () => {
        const editor = editorRef.current;
        if (!editor) {
            return null;
        }
        editor.focus();
        const range = document.createRange();
        range.selectNodeContents(editor);
        range.collapse(false);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return range;
    };

    const captureSelection = () => {
        getSelectionRangeInEditor();
    };

    const setSelectionRange = (range: Range) => {
        const selection = window.getSelection();
        if (!selection) {
            return;
        }
        selection.removeAllRanges();
        selection.addRange(range);
        lastSelectionRef.current = range.cloneRange();
    };

    const getClosestTableCellFromSelection = () => {
        const editor = editorRef.current;
        const range = getSelectionRangeInEditor();
        if (!editor || !range) {
            return null;
        }

        let node: Node | null = range.startContainer;
        if (!node) {
            return null;
        }
        if (node.nodeType === Node.TEXT_NODE) {
            node = node.parentElement;
        }
        if (!node || !(node as Element).closest) {
            return null;
        }
        const cell = (node as Element).closest('td,th');
        if (cell && editor.contains(cell)) {
            return cell as HTMLTableCellElement;
        }
        return null;
    };

    const getClosestTableRowFromSelection = () => {
        const editor = editorRef.current;
        const range = getSelectionRangeInEditor();
        if (!editor || !range) {
            return null;
        }

        let node: Node | null = range.startContainer;
        if (!node) {
            return null;
        }
        if (node.nodeType === Node.TEXT_NODE) {
            node = node.parentElement;
        }
        if (!node || !(node as Element).closest) {
            return null;
        }
        const row = (node as Element).closest('tr');
        if (row && editor.contains(row)) {
            return row as HTMLTableRowElement;
        }
        return null;
    };

    const isEmptyTableCell = (cell: HTMLTableCellElement) => {
        const text = cell.textContent?.replace(/\u00a0/g, '').trim() || '';
        if (text) {
            return false;
        }
        const hasNonTrivialChild = Array.from(cell.childNodes).some((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
                return (child.textContent || '').replace(/\u00a0/g, '').trim() !== '';
            }
            if (child.nodeType !== Node.ELEMENT_NODE) {
                return false;
            }
            const element = child as HTMLElement;
            return element.tagName !== 'BR';
        });
        return !hasNonTrivialChild;
    };

    const insertTextIntoCell = (cell: HTMLTableCellElement, text: string) => {
        if (isEmptyTableCell(cell)) {
            cell.setAttribute('style', TABLE_CELL_STYLE);
            cell.textContent = text;
            const range = document.createRange();
            range.selectNodeContents(cell);
            range.collapse(false);
            setSelectionRange(range);
            return;
        }

        const range = (() => {
            const selection = window.getSelection();
            if (selection && selection.rangeCount > 0) {
                const currentRange = selection.getRangeAt(0);
                if (cell.contains(currentRange.commonAncestorContainer)) {
                    return currentRange;
                }
            }
            const fallback = document.createRange();
            fallback.selectNodeContents(cell);
            fallback.collapse(false);
            return fallback;
        })();

        range.deleteContents();
        const textNode = document.createTextNode(text);
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.collapse(true);
        setSelectionRange(range);
    };

    const upsertRowLabelAndPlaceholder = (cellInRow: HTMLTableCellElement, label: string, key: string) => {
        const row = cellInRow.closest('tr');
        if (!row) {
            insertTextIntoCell(cellInRow, `{{${key}}}`);
            return;
        }

        let cells = Array.from(row.querySelectorAll(`td:not(${TABLE_ACTION_CELL_SELECTOR}),th`)) as HTMLTableCellElement[];
        while (cells.length < 2) {
            const newCell = document.createElement('td');
            newCell.setAttribute('style', TABLE_CELL_STYLE);
            newCell.innerHTML = '&nbsp;';
            const actionCell = row.querySelector(TABLE_ACTION_CELL_SELECTOR);
            row.insertBefore(newCell, actionCell);
            cells = Array.from(row.querySelectorAll(`td:not(${TABLE_ACTION_CELL_SELECTOR}),th`)) as HTMLTableCellElement[];
        }

        const labelCell = cells[0];
        const valueCell = cells[1];

        labelCell.setAttribute('style', TABLE_CELL_STYLE);
        valueCell.setAttribute('style', TABLE_CELL_STYLE);

        if (isEmptyTableCell(labelCell)) {
            labelCell.textContent = label;
        }

        if (!isEmptyTableCell(valueCell)) {
            toast.error(translations?.EMAIL_TEMPLATE_RULE_ENGINE?.CELL_ERROR);
            return;
        }

        insertTextIntoCell(valueCell, `{{${key}}}`);
    };

    const ensureTableTbody = (table: HTMLTableElement) => {
        let tbody = table.querySelector('tbody');
        if (!tbody) {
            tbody = document.createElement('tbody');
            table.appendChild(tbody);
        }
        return tbody;
    };

    const appendEmptyRowToTable = (table: HTMLTableElement) => {
        const tbody = ensureTableTbody(table);
        const row = document.createElement('tr');
        row.innerHTML = `
            <td style="${TABLE_CELL_STYLE}">&nbsp;</td>
            <td style="${TABLE_CELL_STYLE}">&nbsp;</td>
        `;
        tbody.appendChild(row);
    };

    const insertHtmlAtCursor = (html: string) => {
        let range = getSelectionRangeInEditor();
        if (!range) {
            range = focusEditorToEnd();
        }
        if (!range) {
            return;
        }
        const editor = editorRef.current;
        if (!editor) return;

        const existingTable = getClosestTableFromSelection() || editor.querySelector("table");
        if (existingTable) {
            appendEmptyRowToTable(existingTable as HTMLTableElement);
            return;
        }
        
        range.deleteContents();
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const fragment = document.createDocumentFragment();
        let node;
        while ((node = temp.firstChild)) {
            fragment.appendChild(node);
        }
        range.insertNode(fragment);
        range.collapse(false);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const insertTextAtCursor = (text: string) => {
        let range = getSelectionRangeInEditor();
        if (!range) {
            range = focusEditorToEnd();
        }
        if (!range) {
            return;
        }
        range.deleteContents();
        const textNode = document.createTextNode(text);
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.collapse(true);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const getClosestTableFromSelection = () => {
        const editor = editorRef.current;
        const range = getSelectionRangeInEditor();
        if (!editor || !range) {
            return null;
        }
        let node: Node | null = range.startContainer;
        if (!node) {
            return null;
        }
        if (node.nodeType === Node.TEXT_NODE) {
            node = node.parentElement;
        }
        if (!node || !(node as Element).closest) {
            return null;
        }
        const table = (node as Element).closest('table');
        if (table && editor.contains(table)) {
            return table as HTMLTableElement;
        }
        return null;
    };

    const moveCaretOutsideTable = (table: HTMLTableElement, direction: 'before' | 'after') => {
        const editor = editorRef.current;
        if (!editor) {
            return;
        }
        const parentNode = table.parentNode;
        if (!parentNode) {
            return;
        }

        let targetNode: Node | null = direction === 'before' ? table.previousSibling : table.nextSibling;
        let placeAtEnd = direction === 'before';

        if (!targetNode) {
            const spacer = document.createElement('div');
            spacer.innerHTML = '<br>';
            if (direction === 'before') {
                parentNode.insertBefore(spacer, table);
            } else {
                parentNode.insertBefore(spacer, table.nextSibling);
            }
            targetNode = spacer;
            placeAtEnd = false;
        }

        editor.focus();
        const range = document.createRange();
        if (targetNode.nodeType === Node.TEXT_NODE) {
            const textLength = targetNode.textContent?.length || 0;
            range.setStart(targetNode, placeAtEnd ? textLength : 0);
            range.collapse(true);
        } else {
            range.selectNodeContents(targetNode);
            range.collapse(!placeAtEnd);
        }
        setSelectionRange(range);
    };

    const isEmptyTableRow = (row: HTMLTableRowElement) => {
        const cells = Array.from(row.querySelectorAll(`td:not(${TABLE_ACTION_CELL_SELECTOR})`));
        if (cells.length !== 2) {
            return false;
        }
        return cells.every((cell) => cell.textContent?.replace(/\u00a0/g, '').trim() === '');
    };

    const insertRowIntoTable = (table: HTMLTableElement, label: string, key: string, rowToInsertAfter: HTMLTableRowElement | null = null) => {
        let tbody = table.querySelector('tbody');
        if (!tbody) {
            tbody = document.createElement('tbody');
            table.appendChild(tbody);
        }

        const rows = Array.from(tbody.querySelectorAll('tr')) as HTMLTableRowElement[];
        if (!rowToInsertAfter && rows.length === 1 && isEmptyTableRow(rows[0])) {
            const cells = rows[0].querySelectorAll(`td:not(${TABLE_ACTION_CELL_SELECTOR})`);
            if (cells.length >= 2) {
                cells[0].setAttribute('style', TABLE_CELL_STYLE);
                cells[1].setAttribute('style', TABLE_CELL_STYLE);
                cells[0].textContent = label;
                cells[1].textContent = `{{${key}}}`;
                return;
            }
        }

        const currentRow = rowToInsertAfter || getClosestTableRowFromSelection();
        const row = document.createElement('tr');
        const labelCell = document.createElement('td');
        labelCell.setAttribute('style', TABLE_CELL_STYLE);
        labelCell.textContent = label;
        const valueCell = document.createElement('td');
        valueCell.setAttribute('style', TABLE_CELL_STYLE);
        valueCell.textContent = `{{${key}}}`;
        row.appendChild(labelCell);
        row.appendChild(valueCell);

        if (currentRow && currentRow.closest('table') === table && currentRow.parentElement === tbody) {
            tbody.insertBefore(row, currentRow.nextSibling);
        } else {
            tbody.appendChild(row);
        }

        const range = document.createRange();
        range.selectNodeContents(valueCell);
        range.collapse(false);
        setSelectionRange(range);
    };


    const handleForwardButtonClick = () => {
        if (!templateKey) {
            return;
        }
        if (activeTemplateField === 'subject' && showSubjectInput) {
            if (templateKey === 'table' || Array.isArray(templateKey)) {
                toast.error(translations?.EMAIL_TEMPLATE_RULE_ENGINE?.SELECT_TEMPLATE_FIELD || 'Please select template field');
                return;
            }
            insertTextIntoSubject(`{{${templateKey}}}`);
            setPlaceholders((prev: any) => {
                return [...prev, `{{${templateKey}}}`];
            });
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }
        if (templateKey === 'table') {
            insertHtmlAtCursor(TABLE_TEMPLATE);
            syncEditorState();
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }
        
        setPlaceholders((prev: any) => {
            return [...prev, `{{${templateKey}}}`];
        });

        const cell = getClosestTableCellFromSelection();
        if (cell) {
            upsertRowLabelAndPlaceholder(cell, templateLabel || templateKey, templateKey);
            syncEditorState();
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }

        const table = getClosestTableFromSelection();
        if (table) {
            insertRowIntoTable(table, templateLabel || templateKey, templateKey);
            syncEditorState();
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }

        insertTextAtCursor(`{{${templateKey}}}`);
        syncEditorState();
        setTemplateKey('');
        setTemplateLabel('');
    };
   
    const handleReverseButtonClick = () => {
        if (!templateKey) {
            return;
        }

        if (activeTemplateField === 'subject' && showSubjectInput) {
            removeTextFromSubject();
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }

        if (!editorRef.current) {
            return;
        }

        if (templateKey === 'table') {
            const table = getClosestTableFromSelection() || editorRef.current.querySelector('table');
            if (table) {
                table.remove();
                syncEditorState();
            }
            setTemplateKey('');
            setTemplateLabel('');
            return;
        }

        const currentHtml = editorRef.current.innerHTML || '';
        if(Array.isArray(templateKey)){
            let updatedHtml = currentHtml;

            for (let i = 0; i < templateKey.length; i++) {
            const key = templateKey[i];

            const rowRegex = new RegExp(
                `<tr[^>]*>(?:(?!<tr)[\\s\\S])*?{{${key}}}(?:(?!<tr)[\\s\\S])*?<\\/tr>`,
                'i' 
            );

            if (rowRegex.test(updatedHtml)) {
               
                updatedHtml = updatedHtml.replace(rowRegex, '');
            } else {
               
                const keyRegex = new RegExp(`{{${key}}}`, ''); 
                updatedHtml = updatedHtml.replace(keyRegex, '');
            }
            }

            editorRef.current.innerHTML = updatedHtml;
        }else{
            const rowRegex = new RegExp(`<tr[^>]*>[\\s\\S]*?{{${templateKey}}}[\\s\\S]*?<\\/tr>`, 'gi');
            let updatedHtml = currentHtml.replace(rowRegex, '');
            const keyRegex = new RegExp(`{{${templateKey}}}`, 'g');
            updatedHtml = updatedHtml.replace(keyRegex, '');
            editorRef.current.innerHTML = updatedHtml;
        }
        
        syncEditorState();
        setTemplateKey('');
        setTemplateLabel('');
    };

    const handleEditorKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
            return;
        }

        const selection = window.getSelection();
        if (!selection || !selection.isCollapsed) {
            return;
        }

        const table = getClosestTableFromSelection();
        const row = getClosestTableRowFromSelection();
        if (!table || !row) {
            return;
        }

        const rows = Array.from(table.rows);
        const rowIndex = rows.indexOf(row);
        if (rowIndex === -1) {
            return;
        }

        if (e.key === 'ArrowUp' && rowIndex === 0) {
            e.preventDefault();
            moveCaretOutsideTable(table, 'before');
        }

        if (e.key === 'ArrowDown' && rowIndex === rows.length - 1) {
            e.preventDefault();
            moveCaretOutsideTable(table, 'after');
        }
    };


    const SaveTemplateField = async (templateDataOverride: any = null, skipSubjectValidation = false) => {
        const templateData = templateDataOverride ? { ...selectedTemplateData, ...templateDataOverride } : { ...selectedTemplateData };
        if (editorRef.current) {
            templateData.description = getCleanEditorHtml();
        }
        setLoading(true);
        if (await validForm(templateData, skipSubjectValidation)) {
            let saveParams: any = {
                email: templateData.email,
                description: HELPER.EncodetoBase64(templateData.description),
                subject: templateData?.subject || '',
                status: templateData.status
            };

            const updateBranch = structuredClone(templateDetails);
            let letestBranch = null;

            if(templateData?.template_for === TEMPLATE_TYPE_BROKER && COUNTRY_CODE==='id'){

                letestBranch = updateBranch?.cohort_list?.find((row:any)=>row.branch_id == selectedCountryFilters?.branch_id 
                    && row.template_for===templateData?.template_for
                    && row.template_type===templateData.template_type && row.insurance_type===templateData.insurance_type
                );

                if(letestBranch?.template_id){
                    // Existing tuple found: keep update flow even when isNew is true.
                    templateData.template_id = letestBranch?.template_id
                }
                else if(!letestBranch?.branch_id){
                   delete templateData.template_id
                }
            }
            if(templateData?.template_for === TEMPLATE_TYPE_POLICY_SHARED && COUNTRY_CODE==='id'){

               letestBranch = updateBranch?.cohort_list?.find((row:any)=>row.template_for===templateData?.template_for
                && row.template_type===templateData.template_type && row.insurance_type===templateData.insurance_type
            );

                if(COUNTRY_CODE=='id' && letestBranch?.template_id){
                    templateData.template_id = letestBranch?.template_id
                }
                else if(COUNTRY_CODE=='id' && !letestBranch){
                    delete templateData.template_id
                }
            }
            

            

            if (templateData.template_id) {
                saveParams['templateID'] = templateData.template_id;
                saveParams['template_for'] = templateData.template_for;
                saveParams['template_type'] = templateData.template_type;
                saveParams['partner_id'] = searchParams.get('partner_id');
                saveParams['email'] = templateData?.email
            } else {
                saveParams['template_type'] = templateData.template_type;
                saveParams['template_for'] = templateData.template_for;
                saveParams['partner_id'] = searchParams.get('partner_id');
                saveParams['email'] = templateData?.email

                if([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(templateData.insurance_type)){
                    saveParams['dealer_present'] = templateData?.dealer_present
                }

            }
            if (COUNTRY_CODE === 'id') {
                if (selectedCountryFilters?.insurer_id) {
                    saveParams['insurer_id'] = selectedCountryFilters?.insurer_id;
                }
                if (selectedCountryFilters?.branch_id) {
                    saveParams['branch_id'] = selectedCountryFilters?.branch_id;
                }
            }
            saveParams.insurance_type = templateData.insurance_type
            
            updateTemplate(saveParams).then(async (res: any) => {
                if (res.status === STATUS_SUCCESS) {
                    setSelectedTemplateData({ ...templateData, template_id: res.data.id });
                    await dispatch(getMasterConfig());
                    toast.success(res.message);
                    setLoading(false);
                    if(isNew) setIsNew(false);
                    SetTrigger(trigger + 1);
                    if(res?.data?.id){
                        setShowFiled(true);
                    }

                } else {
                    setLoading(false);
                }
            });
        }
        else {
            setLoading(false);
        }
    }

    const submitFilter = () => {
        setLoading(true);
        if(isNew) setIsNew(false);
        if (selectedFilters.template_type && selectedFilters.template_for && selectedFilters.insurance_type) {

            
            let filteredTemplate: any = templateDetails?.cohort_list?.find((elm: any) => (+elm.template_for === +selectedFilters.template_for && +elm.template_type === +selectedFilters.template_type && +elm.insurance_type === +selectedFilters.insurance_type && (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(+elm.insurance_type) && +elm.dealer_present === +selectedFilters.dealer_present) || ([APP_TYPE_WITH_UCF, APP_TYPE_AGENCY].includes(+elm.insurance_type) && !elm.dealer_present))));
            if(COUNTRY_CODE==='id'){
              filteredTemplate = templateDetails?.cohort_list?.find((elm: any) => +elm.template_for === +selectedFilters.template_for && +elm.template_type === +selectedFilters.template_type && +elm.insurance_type === +selectedFilters.insurance_type && [APP_TYPE_STANDALONE, APP_TYPE_AGENCY].includes(+elm.insurance_type));
            }
            setSelectedTemplateData({});
            setShowForm(false)
            setShowFiled(false);
            setShowTemplateConfiguration(false);

            const insurerParam = normalizeQueryValue(searchParams.get('insurer_id'));
            const insurerBranch = commonState?.common?.branch_name?.filter((v: any) => v.insurer_id === insurerParam);
            let defaultBranch = insurerBranch?.find((v: any) => v.is_hq === IS_HQ);

            if (filteredTemplate && filteredTemplate.partner_id) {
                if(COUNTRY_CODE!=='id'){
                    setSelectedTemplateData(filteredTemplate); 
                }
                if (COUNTRY_CODE === 'id') {

                    const updatetemplateDetails = structuredClone(templateDetails);
                    const preferredBranchId = selectedCountryFilters?.branch_id || defaultBranch?.value;
                    let letestCohortList = updatetemplateDetails?.cohort_list?.find((row:any)=>row.branch_id == preferredBranchId
                    && row.template_for===selectedFilters.template_for && row.template_type===selectedFilters.template_type && row.insurance_type===selectedFilters.insurance_type);
                    
                    if(!letestCohortList) {
                       letestCohortList =  updatetemplateDetails?.cohort_list?.find((row:any)=>
                       row.template_for===selectedFilters.template_for && row.template_type===selectedFilters.template_type && row.insurance_type===selectedFilters.insurance_type);
                    }
                    
                   
                    const branchEmail = commonState?.common?.branch_name?.find(
                        (v: any) => +(v.value) === +(letestCohortList?.branch_id)
                    )?.email;
                    if (branchEmail) {
                        setEmailModalValue(branchEmail);
                    }
                    setSelectedTemplateData({...letestCohortList,email: branchEmail, subject: letestCohortList?.subject || ''});

                    
                    const nextHtml = normalizeDescriptionForEditor(
                    letestCohortList?.description || ''
                    );

                    setTimeout(() => {
                    const editor = document.querySelector('.template-editor');
                    if (!editor) return;

                    editor.innerHTML = nextHtml;
                    applyConsistentTableStyles(editor as HTMLElement);
                    addTableRowInsertControls(editor as HTMLElement);
                    }, 0);
                    
                    const isBranchIdActive:boolean =insurerBranch?.some((v: any) => +v.value === +(letestCohortList?.branch_id || preferredBranchId || filteredTemplate?.branch_id));
                    const branchId:number = isBranchIdActive ? +(letestCohortList?.branch_id || preferredBranchId || filteredTemplate?.branch_id) : 0;
                   
                    setSelectedCountryFilters((prev: any) => ({
                        ...prev,
                        branch_id: branchId
                    }));
                }

                setShowForm(true)
                setShowFiled(true);
                setShowTemplateConfiguration(true);
                // if template for is whatsapp then email field would reset during reset
                if (selectedFilters?.template_type === 2) {
                    setShowEmailField(true)
                } else {
                    setShowEmailField(false);
                }
            }
            else {
                setLoading(false);
                toast.error(`${translations.EMAIL_TEMPLATE_RULE_ENGINE?.NO_FINANCIER}`);

            }
        }

        leftSideFieldsHandler(selectedFilters);

        setLoading(false);

    }

    const leftSideFieldsHandler = (params: any) => {
        // filter Details according to template For
        if (Object.keys(originalGroupedData)?.length > 0) {
            let filteredData: any = [...Object.values(originalGroupedData)];
            const newObject = {
                id: 5,
                name: "Template Components",
                parent_id: 0,
                field_key: "template_components",
                status: 1,
                order: 1,
                send_to_insurance_broker: 1,
                insurance_policy_shared: 1,
                child: {
                    "46": {
                        id: 46,
                        name: "Table",
                        parent_id: 4,
                        field_key: "table",
                        status: 1,
                        order: 2,
                        send_to_insurance_broker: 1,
                        insurance_policy_shared: 1,
                        child: []
                    }
                }
            };
            const formattedNewObject = {
                ...newObject,
                child: Object.values(newObject.child).sort(
                    (a: any, b: any) => a.order - b.order
                )
            };
            if (params.template_for === 2) {
                filteredData = filteredData.filter((item: any) =>
                    +item.insurance_policy_shared === 1
                );

                setGroupedData({ ...filteredData,formattedNewObject });
            }
            else if (params.template_for === 1) {
                filteredData = filteredData.filter((item: any) =>
                    +item.send_to_insurance_broker === 1
                );
                setGroupedData({ ...filteredData,formattedNewObject });
            }
        }

    }

    const handleTemplateData = (e: any, key: string) => {

        let value = "";
        if (key === "status") {
            value = +selectedTemplateData.status ? '0' : '1'
        }

        setSelectedTemplateData({ ...selectedTemplateData, [key]: value })
    }

    //sub filter handle
    const addTemplateFieldHandler = (e: any, key: string) => {

        if(COUNTRY_CODE==='id'  && key === 'template_type'){
            const check  = checkTableExistence(e.value);
            if(!check) return toast.error(`${translations.EMAIL_TEMPLATE_RULE_ENGINE?.REMOVE_CONTENT}`);
        
        }

        let updatedSelectedData = { ...selectedTemplateData, [key]: (key === "email" ? e.target.value : e.value) };

        setSelectedTemplateData(updatedSelectedData);
        if (key === 'template_for') {
            setSelectedTemplateData({ ...updatedSelectedData, template_type: '' });
            // when user change Select Template then reset description
            if (updatedSelectedData.description) {
                delete updatedSelectedData.description;
            }
            if (updatedSelectedData.subject) {
                delete updatedSelectedData.subject;
            }
            let newList = templateDetails?.cohort_list?.filter((ob: any) => +ob.template_for === +e.value && +ob.insurance_type === updatedSelectedData?.insurance_type && (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(updatedSelectedData?.insurance_type)  && ob.dealer_present === updatedSelectedData.dealer_present) || (updatedSelectedData?.insurance_type === APP_TYPE_WITH_UCF))).map((val: any) => +val.template_type);
            templateDetails.templateType = originalTemplateType.filter((ob: any) => !newList?.includes(+ob.value))

            setTemplateDetails(templateDetails);
            setShowTemplateConfiguration(false);

            leftSideFieldsHandler(updatedSelectedData);

        }
        if (key === 'template_type') {
            setShowEmailField(false);
           
            
            

            if (e.value !== 1) {
                setShowEmailField(true);
            }

            // Email will blank in whatsapp case only
            if (+updatedSelectedData?.template_type === 2) {
                updatedSelectedData.email = '';
                updatedSelectedData.subject = '';
                setSelectedTemplateData(updatedSelectedData);
            }


            let newList = templateDetails?.cohort_list?.filter((ob: any) =>  +ob.insurance_type === updatedSelectedData?.insurance_type && (+ob.template_for === +updatedSelectedData.template_for) && (+ob.template_type === +updatedSelectedData.template_type)).map((val: any) => +val.dealer_present);
            templateDetails.dealerPresent = originalDealerSelect.filter((ob: any) => !newList?.includes(+ob.value))

        }
        if (key === 'insurance_type') {

            // when user change Insurance Type then it reset Select Template
            if (updatedSelectedData.template_for) {
                delete updatedSelectedData.template_for;
            }
        }

        if ((updatedSelectedData?.template_for === TEMPLATE_TYPE_BROKER)) {
            setShowPermission(HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['sent_to_insurance_broker'], accessType: 'edit' }));
        }
        else if ((updatedSelectedData?.template_for === TEMPLATE_TYPE_POLICY_SHARED)) {
            setShowPermission(HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_policy'], accessType: 'edit' }))
        }

    }

    // on cancel page re-direct to listing
    const CancelTemplateField = () => {
        if (window.confirm(resetWarningMsg)) {
            navigate('/email-template-config');
        }
    }

    useEffect(() => {
        // Check if 'partner_id' parameters are present
        if (!searchParams.get('partner_id')) {
            navigate('/email-template-config');
        }
    }, [searchParams, navigate]);

    useEffect(() => {
        const editor = editorRef.current;
        if (!editor) {
            return;
        }
        const nextHtml = normalizeDescriptionForEditor(selectedTemplateData?.description || '');
        if (document.activeElement === editor) {
            return;
        }
        if (editor.innerHTML !== nextHtml) {
            editor.innerHTML = nextHtml;
            applyConsistentTableStyles(editor);
            addTableRowInsertControls(editor);
        }
    }, [selectedTemplateData?.description]);

    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i); // eslint-disable-line  

    // Function to validate the form
    const validForm = async (formData: any = selectedTemplateData, skipSubjectValidation = false) => {
        let formIsValid = true;
        setErrField({
            email: "",
            subject: "",
            description: "",

        });

        // if (selectedTemplateData.email === "" && selectedTemplateData?.template_type === 1) {
        //     formIsValid = false;
        //     setErrField((prevState: any) => ({
        //         ...prevState,
        //         email: "Email is required",
        //     }));
        // }
        if (COUNTRY_CODE ==='id' && formData.email && !validEmailRegex.test(formData.email) 
            && formData?.template_type === SHARE_METHOD.email
           && formData.template_for ===TEMPLATE_TYPE_BROKER
        ) {
            let multipleEmailChk = formData.email.split(',');
            for (const email of multipleEmailChk) {
                if (!validEmailRegex.test(email.trim())) {
                    formIsValid = false;
                    setErrField((prevState: any) => ({
                        ...prevState,
                        email: "Please enter valid email",
                    }));
                    break;
                }
            }
        }

        if (COUNTRY_CODE ==='id' && !selectedCountryFilters?.branch_id && formData.template_for ===TEMPLATE_TYPE_BROKER){
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                branch_id: "Please select branch",
            }));
        }

        if (COUNTRY_CODE!=='id' && !formData.dealer_present && [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(formData?.insurance_type)) {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                dealer_present: "Dealer present is required",
            }));
        }

        if (!skipSubjectValidation && ENABLE_EMAIL_TEMPLATE_SUBJECT && +formData?.template_type === SHARE_METHOD.email && !formData?.subject?.trim()) {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                subject: translations.EMAIL_TEMPLATE_RULE_ENGINE?.SUBJECT_REQUIRED || 'Subject is required',
            }));
        }

        let checkValidKeys = checkFieldKeyExists(originalGroupedData)
        if (checkValidKeys) {
            if (!checkValidKeys.sentToBrokerKeys.includes('{{table}}')) {
                checkValidKeys.sentToBrokerKeys.push('{{table}}');
            }
            if (!checkValidKeys.policySharedKeys.includes('{{table}}')) {
                checkValidKeys.policySharedKeys.push('{{table}}');
            }
        }

        const regex = /{{(.*?)}}/g;
        const descriptionKeys = formData.description.match(regex); //GET ALL KEYS IN TEXT
        const subjectKeys = ENABLE_EMAIL_TEMPLATE_SUBJECT && +formData?.template_type === SHARE_METHOD.email
            ? (formData?.subject || '').match(regex)
            : null;
        const templateKeys = [...(descriptionKeys || []), ...(subjectKeys || [])];

        let fieldKeyError = false;
        if (+formData.template_for === 1) { //SENT TO BROKER TEMPLATE

            let unwantedKeys = templateKeys.filter((x: any) => {
                if (checkValidKeys && checkValidKeys.sentToBrokerKeys) {
                    return !checkValidKeys.sentToBrokerKeys.includes(x);
                }
                // handle the case when sentToBrokerKeys is undefined
                return false;
            });

            if (unwantedKeys?.length) {
                formIsValid = false;
                fieldKeyError = true;
            }

        } else { //POLICY SHARED 

            let unwantedKeys = templateKeys.filter((x: any) => !checkValidKeys?.policySharedKeys?.includes(x));

            if (unwantedKeys?.length) {
                formIsValid = false;
                fieldKeyError = true;
            }
        }

        if (fieldKeyError) {
            toast.error(`${translations.EMAIL_TEMPLATE_RULE_ENGINE?.KEY_NOT_ALLOW}`);
        }

        return formIsValid;
    };

    //GET ALL FIELDS KEYs
    const checkFieldKeyExists = (fieldData: any): any => {
        let sentToBrokerKeys: any = [];
        let policySharedKeys: any = [];
        for (const key in fieldData) {
            const topLevelObject: any = fieldData[key];

            let childsLength = (topLevelObject.child) ? (Array.isArray(topLevelObject.child) ? Object.assign({}, topLevelObject.child) : (topLevelObject.child)) : {};
            if (Object.keys(childsLength).length) {

                let allKeys = checkFieldKeyExists(topLevelObject.child);
                sentToBrokerKeys = [...sentToBrokerKeys, ...allKeys.sentToBrokerKeys]
                policySharedKeys = [...policySharedKeys, ...allKeys.policySharedKeys]

            } else {
                if (topLevelObject.send_to_insurance_broker && +topLevelObject.insurance_policy_shared) {

                    sentToBrokerKeys.push(`{{${topLevelObject.field_key}}}`)
                    policySharedKeys.push(`{{${topLevelObject.field_key}}}`)

                }
                else {
                    if (topLevelObject.send_to_insurance_broker) {
                        sentToBrokerKeys.push(`{{${topLevelObject.field_key}}}`)

                    } else {
                        policySharedKeys.push(`{{${topLevelObject.field_key}}}`)
                    }
                }

            }

        }
        return { sentToBrokerKeys, policySharedKeys };

    };

    const resetHandler = () => {
        // when data is added
        if (selectedTemplateData.partner_id === undefined || selectedTemplateData.partner_id === null) {
            setSelectedTemplateData({ ...selectedTemplateData, template_for: '', template_type: '', email: '', description: '', subject: '', insurance_type: '' });
            if (editorRef.current) {
                editorRef.current.innerHTML = '';
            }
        }
        //when data is Edited
        if (selectedTemplateData?.partner_id) {
            setSelectedTemplateData({ ...selectedTemplateData, email: '' });
        }
        setTemplateKey('');
        setTemplateLabel('');
        setSelectedCountryFilters(getPrefilledCountryFilters());
        lastSelectionRef.current = null;
        subjectSelectionRef.current = { start: 0, end: 0 };

    }

    useEffect(() => {
        if (Object.keys(commonState.common).length === 0 && COUNTRY_CODE !== 'id') {
            dispatch(getMasterConfig());
        }
        if(COUNTRY_CODE === 'id'){
            dispatch(getMasterConfig());
        }
        // eslint-disable-next-line
    }, []);

    const isPartnerLocked = !!searchParams.get('insurance_partner_id');
    const isInsurerLocked = !!searchParams.get('insurer_id');
    
    const insurerIdParam = normalizeQueryValue(searchParams.get('insurer_id'));
    const resolvedInsurerId = selectedCountryFilters?.insurer_id || insurerIdParam;
    const insurerNameFromConfig = commonState?.common?.insurer_list_with_partner_id?.find(
        (v: any) => v.value === resolvedInsurerId
    )?.label || '';
    const subHeadingText = COUNTRY_CODE === 'id' ? (templateDetails?.insurer_name || insurerNameFromConfig || '') : templateDetails?.financier_name;
    const emailList = getEmailList(selectedTemplateData?.email || '');
    const emailPreview = emailList[0] || '';
    const emailMoreCount = emailList.length > 1 ? emailList.length - 1 : 0;
    const isEmailEditDisabled = showEmailField;
    const showSubjectInput = ENABLE_EMAIL_TEMPLATE_SUBJECT && +selectedTemplateData?.template_type === SHARE_METHOD.email;

    const selectedText = window.getSelection()?.toString();
    
    useEffect(() => {
        if(selectedText && COUNTRY_CODE==='id'){
            const templateKeys = selectedText
            .match(/{{(.*?)}}/g)
            ?.map(k => k.replace(/[{}]/g, '')) || [];
           setTemplateKey(templateKeys);
        }
    },[selectedText])

    let appType = commonState?.common?.apptype;
    if(COUNTRY_CODE==='id'){
        appType = appType?.map((row:any)=>{
            return {
                ...row,
                label:row.value===APP_TYPE_STANDALONE?'CRM':row.label
            }
        })
    }

    document.addEventListener('keydown', function (e) {
        
        if(COUNTRY_CODE!=='id') return
        if (e.key !== 'Backspace') return;

        const selection = window.getSelection();
        
        if(selection){
            let node = selection.anchorNode;
            if(!node) return

            if (node.nodeType !== 3) {
                node = node.childNodes[selection.anchorOffset - 1] || node.childNodes[0];
            }
          
            if (!node || node.nodeType !== 3) return;
            
            const text = node.textContent;
            
            if(text){

                const cursorPos = selection.anchorOffset;
                
                for (let placeholder of Placeholders) {
                    let startIndex = text.indexOf(placeholder);
                
                    while (startIndex !== -1) {
                    const endIndex = startIndex + placeholder.length;
                
                    if (cursorPos > startIndex && cursorPos <= endIndex) {
                        e.preventDefault();
                        return;
                    }
                
                     startIndex = text.indexOf(placeholder, startIndex + 1);
                    }
                }
            }

        }
    });

    let dynamicClassName = ''
    if(COUNTRY_CODE==='id' 
        && selectedTemplateData?.template_for === TEMPLATE_TYPE_POLICY_SHARED
    ){
        dynamicClassName = 'financier-top-filter-policy'
    }
    if(COUNTRY_CODE==='id' 
        && selectedTemplateData?.template_for === TEMPLATE_TYPE_BROKER
        
    ){
        dynamicClassName = 'financier-top-filter-id'
    }

    
    useEffect(() => {
        if(COUNTRY_CODE!=='id') return
        if (!groupedData) return;

        const updatedGroupData = structuredClone(existingGroupData);
        if (selectedTemplateData?.template_type === TEMPLATE_TYPE.WP) {
            Object.keys(updatedGroupData).forEach((key) => {
                if (updatedGroupData[key]?.field_key === "template_components") {
                    delete updatedGroupData[key];
                }
            });

        }
        setGroupedData(updatedGroupData);

    }, [selectedTemplateData?.template_type]);

    const handlePaste = (e: any) => {

        const html = e.clipboardData.getData("text/html");
        const text = e.clipboardData.getData("text/plain");

        const content = (html || text || "").toLowerCase();

        const hasTable = /<table[\s>]/.test(content) || /&lt;table[\s>]/.test(content);

        if (
            selectedTemplateData?.template_type === TEMPLATE_TYPE.WP &&
            hasTable
        ) {
            e.preventDefault();
            toast.error(`${translations.EMAIL_TEMPLATE_RULE_ENGINE?.CONTENT_NOT_ALLOW}`);
            return;
        }

        if (html && hasTable) {
            e.preventDefault();
            const normalizedHtml = normalizePastedTables(html);
            const inserted = document.execCommand('insertHTML', false, normalizedHtml);
            if (!inserted) {
                insertHtmlAtCursor(normalizedHtml);
            }
            applyConsistentTableStyles(editorRef.current);
            syncEditorState();
        }
    };
    const checkTableExistence = (value: number) => {
        let isvalid = true;
        if (!value) return;

        if (editorRef.current && value === TEMPLATE_TYPE.WP) {
            const content = editorRef.current.innerHTML.toLowerCase();

            const hasTable = /<table[\s>]/.test(content) || /&lt;table[\s>]/.test(content);

            if (hasTable) {
                isvalid = false;
            }
        }

        return isvalid;
    };

    const captureSubjectSelection = () => {
        const subjectInput = subjectRef.current;
        if (!subjectInput) {
            return;
        }
        subjectSelectionRef.current = {
            start: subjectInput.selectionStart || 0,
            end: subjectInput.selectionEnd || 0
        };
    };

    const insertTextIntoSubject = (text: string) => {
        const subjectValue = selectedTemplateData?.subject || '';
        const { start, end } = subjectSelectionRef.current;
        const nextSubject = `${subjectValue.slice(0, start)}${text}${subjectValue.slice(end)}`;
        const caretPosition = start + text.length;

        setSelectedTemplateData((prevState: any) => ({ ...prevState, subject: nextSubject }));

        requestAnimationFrame(() => {
            subjectRef.current?.focus();
            subjectRef.current?.setSelectionRange(caretPosition, caretPosition);
            subjectSelectionRef.current = { start: caretPosition, end: caretPosition };
        });
    };

    const removeTextFromSubject = () => {
        const subjectValue = selectedTemplateData?.subject || '';
        if (!subjectValue) {
            return;
        }

        const keys = Array.isArray(templateKey) ? templateKey : [templateKey];
        const nextSubject = keys.reduce((value: string, key: string) => {
            return value.replace(new RegExp(`{{${key}}}`, 'g'), '');
        }, subjectValue);

        setSelectedTemplateData((prevState: any) => ({ ...prevState, subject: nextSubject }));
        requestAnimationFrame(() => {
            subjectRef.current?.focus();
            captureSubjectSelection();
        });
    };

    useEffect(() => {
        if (templateDetails && COUNTRY_CODE==='id') {
            submitFilter();
        }
    }, [templateDetails]);
    
    

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="top-heading-outer">
                <div className="back-opt">
                    <Link to="/email-template-config" title="Back">
                        <i className="ic-arrow_back"></i>
                       {translations.commonMsg?.back}
                    </Link>
                </div>
                <div className="top-heading">
                    <h1> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.SEND_FINANCIER_TEMPLATE || translations.commonMsg?.loading}</h1>
                </div>
                <div className="sub-heading">{subHeadingText}</div>
            </div>
            <div className="container-fluid">
                <div className="financier-detail-outer">
                    <div className='filter-filed-form'>
                        {/* Insurance Type dropdown for Searcing case*/}
                        <ReactSelect
                            options={appType || []}
                            value={appType?.find((v: any) => +v.value === +selectedFilters['insurance_type']) || null}
                            handleChange={(e: any, fieldKey: string) => handleChange(e, fieldKey)} placeholder={translations.Insurance?.['Select Insurance Type'] || translations.commonMsg?.loading} fieldKey="insurance_type"
                        />

                        <ReactSelect options={templateDetails?.templateFor || []}
                            value={templateDetails['templateFor']?.find((v: any) => +v.value === +selectedFilters['template_for']) || null}
                            handleChange={(e: any, fieldKey: string) => handleChange(e, fieldKey)} placeholder={translations.Insurance?.['Select Template For'] || translations.commonMsg?.loading} fieldKey="template_for"
                        />

                        <ReactSelect options={originalTemplateType}
                            value={originalTemplateType?.filter((v: any) => v.value === selectedFilters['template_type']) || null}
                            handleChange={(e: any, fieldKey: string) => handleChange(e, fieldKey)} placeholder={translations.Insurance?.['Select Template'] || translations.commonMsg?.loading} fieldKey="template_type" key="template_type"
                        />

                        {
                            COUNTRY_CODE!='id' && [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(selectedFilters['insurance_type']) &&
                            <ReactSelect options={originalDealerSelect}
                                value={originalDealerSelect?.filter((v: any) => v.value === selectedFilters['dealer_present']) || null}
                                handleChange={(e: any, fieldKey: string) => handleChange(e, fieldKey)} placeholder="Dealer Present" fieldKey="dealer_present" key="dealer_present"
                            />
                        }

                        <div className="btn-submit-reset">
                            <button className="btn-primary" type="submit" disabled={!(selectedFilters.template_for && selectedFilters.template_type && selectedFilters.insurance_type && (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(selectedFilters.insurance_type) && (COUNTRY_CODE==='id' ? true : selectedFilters.dealer_present)) || ((selectedFilters.insurance_type === APP_TYPE_WITH_UCF)) || ((selectedFilters.insurance_type === APP_TYPE_AGENCY))))} onClick={submitFilter}> {translations.commonMsg?.search}</button>
                            {
                                (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['sent_to_insurance_broker'], accessType: 'edit' }) || HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_policy'], accessType: 'edit' })) &&
                                <button className="btn-line" onClick={addTemplate}>{translations.commonMsg?.addNew}</button>
                            }
                        </div>
                    </div>
                    {showForm &&
                        <>
                            <div className='financier-sub-filter-list'>
                                <div className={`financier-top-filter ${COUNTRY_CODE==='id'?dynamicClassName:''}`}>
                                    {/* Add extra dropdown for Insurance Type duing Add New case only*/}

                                    <ReactSelect options={appType || []}
                                        value={appType?.find((v: any) => +v.value === +selectedTemplateData?.['insurance_type']) || null}
                                        handleChange={(e: any, fieldKey: string) => addTemplateFieldHandler(e, fieldKey)} placeholder={translations.Insurance?.['Select Insurance Type'] || translations.commonMsg?.loading} fieldKey="insurance_type" key="insurance_type"
                                        isDisabled={showFiled}
                                    />

                                    <ReactSelect options={templateDetails?.templateFor || []}
                                        value={(templateDetails && templateDetails.templateFor && selectedTemplateData?.template_for) ? templateDetails.templateFor?.find((elm: any) => +elm.value === selectedTemplateData?.template_for) : null}
                                        handleChange={(e: any, fieldKey: string) => addTemplateFieldHandler(e, fieldKey)} placeholder={translations.Insurance?.['Select Template'] || translations.commonMsg?.loading} fieldKey="template_for" key="template_for"
                                        isDisabled={showFiled}
                                    />


                                    <ReactSelect options={templateDetails?.templateType || []}
                                        value={(templateDetails && templateDetails.templateType && selectedTemplateData?.template_type) ? templateDetails.templateType?.find((elm: any) => +elm.value === selectedTemplateData?.template_type) : null}
                                        handleChange={(e: any, fieldKey: string) => addTemplateFieldHandler(e, fieldKey)} placeholder={translations.EMAIL_TEMPLATE_RULE_ENGINE?.['TMPLATE_CONFIG'] || translations.commonMsg?.loading} fieldKey="template_type" key="template_type"
                                        isDisabled={showFiled}
                                    />
                                    
                                    {/* field only for ID */}
                                    
                                    {COUNTRY_CODE === 'id' &&
                                        <>
                                            {
                                                FEATURE_LISTING['INSURANCE_LIST']['FILTERS']['INSURANCE_PARTNER'] &&
                                                <ReactSelect
                                                    options={commonState?.common?.partner_list || []}
                                                    value={commonState?.common?.partner_list?.find((v: any) => v.value === selectedCountryFilters['partner_id']) || null}
                                                    handleChange={(e: any, fieldKey: string) => handleCountryFilterChange(e, fieldKey)}
                                                    placeholder={translations.EMAIL_TEMPLATE_RULE_ENGINE?.['SELECT_PARTNER'] || translations.commonMsg?.loading}
                                                    fieldKey="partner_id"
                                                    isDisabled={isPartnerLocked}
                                                />
                                            }

                                            {/* {
                                                FEATURE_LISTING['INSURANCE_LIST']['FILTERS']['INSURER'] &&
                                                <ReactSelect
                                                    options={commonState?.common?.insurer_list_with_partner_id?.filter((e: any) => e.partner_id === selectedCountryFilters?.['partner_id']) || []}
                                                    value={commonState?.common?.insurer_list_with_partner_id?.find((v: any) => v.value === selectedCountryFilters['insurer_id']) || null}
                                                    handleChange={(e: any, fieldKey: string) => handleCountryFilterChange(e, fieldKey)}
                                                    placeholder={translations.Insurance?.['Insurance Name'] || translations.commonMsg?.loading}
                                                    fieldKey="insurer_id"
                                                    isDisabled={isInsurerLocked}
                                                />
                                            } */}


                                            {
                                                selectedTemplateData?.template_for === TEMPLATE_TYPE_BROKER && (

                                                    <ReactSelect
                                                        options={insurerBranch || []}
                                                        value={insurerBranch?.find((v: any) => +v?.value === +selectedCountryFilters['branch_id']) || null}
                                                        handleChange={(e: any, fieldKey: string) => handleCountryFilterChange(e, fieldKey)}
                                                        placeholder={translations.Insurance?.['Branch Name'] || translations.commonMsg?.loading}
                                                        fieldKey="branch_id"
                                                        errorField={errField.branch_id}
                                                    />
                                                )
                                                
                                            }
                                        </>
                                    }

                                    {!showEmailField && COUNTRY_CODE === 'id' && selectedTemplateData?.template_for === TEMPLATE_TYPE_BROKER&&
                                        <fieldset className="email-more">
                                            <div className="material">
                                                <input
                                                    value={emailPreview || ""}
                                                    placeholder={" "}
                                                    className="form-input"
                                                    onClick={openEmailIdsModal}
                                                    type="text"
                                                    title={selectedTemplateData?.email || ""}
                                                />
                                                <label data-label={"Insurer Email ID"} className="form-label"></label>
                                                {emailMoreCount > 0 && (
                                                    <span className="more-text-id" onClick={openEmailIdsModal}>
                                                        {`+ ${emailMoreCount} More`}
                                                    </span>
                                                )}
                                                {errField.email && (
                                                    <span className="error-txt">
                                                        {errField['email']}
                                                    </span>
                                                )}
                                            </div>
                                        </fieldset>
                                    }
                                    {
                                       COUNTRY_CODE !== 'id'  && (
                                        <fieldset className="multiselect-dropDown">
                                            <div className="material animation-effect ">
                                                <input
                                                    value={selectedTemplateData?.email || ""}
                                                    placeholder={" "}
                                                    className="form-input"
                                                    onChange={(e) => addTemplateFieldHandler(e, 'email')}
                                                    type="text"
                                                    disabled={showEmailField}
                                                    title={selectedTemplateData?.email || ""}
                                                />
                                                <label data-label={"Financier Email ID"} className="form-label"></label>
                                                {errField.email && (
                                                    <span className="error-txt">
                                                        {errField['email']}
                                                    </span>
                                                )}
                                            </div>
                                        </fieldset>
                                       )
                                    }
                                    {
                                      COUNTRY_CODE !== 'id' && [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(selectedTemplateData?.insurance_type) &&
                                        <ReactSelect options={templateDetails?.dealerPresent || []}
                                            value={(selectedTemplateData?.dealer_present) ? templateDetails?.dealerPresent?.find((elm: any) => +elm.value === selectedTemplateData?.dealer_present) : null}
                                            handleChange={(e: any, fieldKey: string) => addTemplateFieldHandler(e, fieldKey)} placeholder="Dealer Present" fieldKey="dealer_present" key="dealer_present"
                                            isDisabled={showFiled}
                                        />
                                    }

                                    <div className="btn-submit-reset">
                                        <button className="btn-reset" onClick={resetHandler}> {translations.commonMsg?.reset}</button>
                                    </div>

                                </div>
                            </div>

                            <div className='template-filed-outer'>
                                <div className="swith-txt-outer">
                                    <h3>  {translations.EMAIL_TEMPLATE_RULE_ENGINE?.TEMPLATE_FIELDS || translations.commonMsg?.loading}</h3>
                                    <div className="toggle-switch-outer">
                                        {showPermission &&
                                            <div className="toggleApp">
                                                <div className={`ToggleSwitch ${+selectedTemplateData?.status ? 'active' : ''}`} onClick={(e) => handleTemplateData(e, 'status')}>
                                                    <div className={`knob ${+selectedTemplateData?.status ? 'active' : ''}`}></div>
                                                    <div className="toggle-status">{translations.commonMsg?.publish}</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="templete-list-filed-outer">
                                    <div className="list-left-panel">
                                        {Object.values(groupedData).map((parent: any) => (
                                            <div key={parent.id}>
                                                <h2>{getTranslatedFieldLabel(parent)}</h2>
                                                <ul>
                                                    {Object.values(parent.child).map((child: any) => (
                                                        <li key={child.id}
                                                            data-key={`{{${child.field_key}}}`}
                                                            className={(templateKey === child?.field_key) ? "selected-attribute" : ""}
                                                            onClick={(e) => handleKeySelect(e, child)}

                                                        >
                                                            {
                                                                child?.child?.length ?
                                                                    <strong>{getTranslatedFieldLabel(child)}</strong> :
                                                                    <span>{getTranslatedFieldLabel(child)}</span>
                                                            }
                                                            {(child?.child?.length > 0) &&
                                                                <ul>
                                                                    {
                                                                        Object.values(child?.child).map((innerChild: any) => (

                                                                            <li className={(templateKey === innerChild?.field_key) ? "selected-attribute" : ""} key={innerChild.id} onClick={(e) => handleKeySelect(e, innerChild)} >{getTranslatedFieldLabel(innerChild)}</li>
                                                                        )
                                                                        )
                                                                    }
                                                                </ul>
                                                            }

                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="add-remove-arrow">
                                        <ul>
                                            <li>
                                                <i className="ic-arrow_forward" onClick={handleForwardButtonClick}></i>
                                            </li>
                                            <li><i className="ic-arrow_back" onClick={handleReverseButtonClick}></i></li>
                                        </ul>
                                    </div>
                                    <div className="text-filed-select-area">
                                        {showSubjectInput &&
                                            <fieldset className="form-filed template-subject-field">
                                                <div className={(selectedTemplateData?.subject) ? "active-label material animation-effect" : "material animation-effect"}>
                                                    <input
                                                        ref={subjectRef}
                                                        value={selectedTemplateData?.subject || ""}
                                                        placeholder={" "}
                                                        className="form-input"
                                                        onChange={(e) => {
                                                            setSelectedTemplateData({ ...selectedTemplateData, subject: e.target.value });
                                                            if (errField.subject && e.target.value?.trim()) {
                                                                setErrField((prevState: any) => ({ ...prevState, subject: '' }));
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            setActiveTemplateField('subject');
                                                            captureSubjectSelection();
                                                        }}
                                                        onFocus={() => {
                                                            setActiveTemplateField('subject');
                                                            captureSubjectSelection();
                                                        }}
                                                        onKeyUp={captureSubjectSelection}
                                                        onSelect={captureSubjectSelection}
                                                        type="text"
                                                        title={selectedTemplateData?.subject || ""}
                                                    />
                                                    <label data-label={translations.EMAIL_TEMPLATE_RULE_ENGINE?.SUBJECT || translations.commonMsg?.loading} className="form-label"></label>
                                                    {errField.subject && (
                                                        <span className="error-txt">
                                                            {errField['subject']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                        }
                                        <div
                                            className="template-editor"
                                            contentEditable
                                            suppressContentEditableWarning
                                            data-placeholder={translations.EMAIL_TEMPLATE_RULE_ENGINE?.TEMPLATE_BODY_PLACEHOLDER || translations.commonMsg?.loading}
                                            ref={editorRef}
                                            onInput={handleEditorInput}
                                            onBlur={handleEditorInput}
                                            onClick={(e) => {
                                                setActiveTemplateField('body');
                                                handleEditorClick(e);
                                            }}
                                            onMouseUp={() => {
                                                setActiveTemplateField('body');
                                                captureSelection();
                                            }}
                                            onKeyDown={handleEditorKeyDown}
                                            onKeyUp={() => {
                                                setActiveTemplateField('body');
                                                captureSelection();
                                            }}
                                            onFocus={() => {
                                                setActiveTemplateField('body');
                                                captureSelection();
                                            }}
                                            onPaste={handlePaste}
                                        />
                                    </div>
                                </div>

                                <div className="btn-submit-reset update-btn">
                                    {
                                        showPermission &&
                                        <button className="btn-primary" onClick={(selectedTemplateData?.description?.trim() && selectedTemplateData?.template_type) ? SaveTemplateField : undefined}
                                            disabled={!(selectedTemplateData?.description?.trim() && selectedTemplateData?.template_type && (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(selectedTemplateData?.insurance_type) && (COUNTRY_CODE=='id'?true:selectedTemplateData?.dealer_present)) || [APP_TYPE_WITH_UCF, APP_TYPE_AGENCY].includes(selectedTemplateData?.insurance_type)))}
                                        > {translations.commonMsg?.update}</button>
                                    }
                                    <button className="btn-line" onClick={CancelTemplateField}>{translations.commonMsg?.cancel}</button>

                                </div>
                            </div>
                        </>
                    }
                </div>

                {COUNTRY_CODE === 'id' &&
                    <div className="view-timeline-popup email-popup-id">
                        <Modal show={showEmailIdsModal} handleClose={closeEmailIdsModal}>
                            <div className="modal-header email-config-id">
                                <h2>All Email Ids</h2>
                                <span
                                    className={`cursor-pointer${isEmailEditDisabled ? ' disabled' : ''}`}
                                    onClick={() => {
                                        if (!isEmailEditDisabled) {
                                            setIsEmailEditMode(true);
                                        }
                                    }}
                                >
                                    <i className="ic-edit"></i> {translations.commonMsg?.edit}
                                </span>
                            </div>
                            <div className="modal-body">
                                {
                                    !isEmailEditMode && (
                                        <div className='email-body-id'>
                                            {emailModalValue}
                                        </div>
                                    )
                                }
                                {
                                    isEmailEditMode && (

                                        <fieldset className="form-filed">
                                            <div className="material">
                                                <textarea
                                                    placeholder=" "
                                                    className="form-input"
                                                    rows={5}
                                                    disabled={!isEmailEditMode || isEmailEditDisabled}
                                                    onChange={(e: any) => setEmailModalValue(e.target.value)}
                                                    value={emailModalValue}
                                                />
                                            </div>
                                        </fieldset>
                                    )
                                }
                               
                                {
                                    isEmailEditMode &&

                                    <div className="btn-submit-reset p-lg-t">
                                        <button
                                            className="btn-primary"
                                            disabled={!isEmailEditMode || isEmailEditDisabled}
                                            onClick={saveEmailIdsModal}
                                        >
                                            {translations.commonMsg?.save}
                                        </button>
                                        <button className="btn-line" onClick={closeEmailIdsModal}>{translations.commonMsg?.cancel}</button>
                                    </div>
                                }
                            </div>
                        </Modal>
                    </div>
                }

            </div>
        </React.Fragment>
    );
}

export default SendToFinancierTemplateDetail;
